import i18next from 'i18next';
import { STATISTIC_BY_EXPIRE_DATE_COLORS } from 'appConstants';

const translate = key => {
  if (i18next && typeof i18next.t === 'function') {
    const translated = i18next.t(key);

    if (translated !== undefined && translated !== null) {
      return translated;
    }
  }

  if (i18next && i18next.default && typeof i18next.default.t === 'function') {
    const translated = i18next.default.t(key);

    if (translated !== undefined && translated !== null) {
      return translated;
    }
  }

  return key;
};

const transformToStatisticsByExpireDate = data => {
  const additionalDonutData = {
    expired: {
      legendTitle: translate('legend.expired'),
      fillColor: STATISTIC_BY_EXPIRE_DATE_COLORS.expired,
    },
    not_specified: {
      legendTitle: translate('legend.notSpecified'),
      fillColor: STATISTIC_BY_EXPIRE_DATE_COLORS.not_specified,
    },
    '1_week': {
      legendTitle: translate('legend.expiredInAWeek'),
      fillColor: STATISTIC_BY_EXPIRE_DATE_COLORS['1_week'],
    },
    '1_month': {
      legendTitle: translate('legend.expiredInAMonth'),
      fillColor: STATISTIC_BY_EXPIRE_DATE_COLORS['1_month'],
    },
    '3_month': {
      legendTitle: translate('legend.expiredIn3Month'),
      fillColor: STATISTIC_BY_EXPIRE_DATE_COLORS['3_month'],
    },
    up_to_date: {
      legendTitle: translate('legend.upToDate'),
      fillColor: STATISTIC_BY_EXPIRE_DATE_COLORS.up_to_date,
    },
  };

  if (!data) return [];

  return Object.keys(additionalDonutData)
    .map(key => ({
      ...additionalDonutData[key],
      filterValue: key,
      value: data[key],
    }))
    .filter(item => item.value > 0);
};

export default transformToStatisticsByExpireDate;
